import { connect } from 'react-redux';

import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';
import {
  getIsControlObjectsErvkCorrectionRequired,
  getIsEventErvkCorrectionRequired,
  getIsParticipantPositionErvkCorrectionRequired,
} from '../../../KnmPackage/MainModule/selectors/knmSelectors';

interface IErvkCorrectionRequiredInfoProps {
  checkForControlObjects?: boolean;
  checkForEvent?: boolean;
  checkForInspectors?: boolean;
}

interface IErvkCorrectionRequiredInfoStoreProps {
  isEventErvkCorrectionRequired: boolean;
  isControlObjectsErvkCorrectionRequired: boolean;
  isParticipantPositionErvkCorrectionRequired: boolean;
}

const ErvkCorrectionRequiredInfoWithoutStore = ({
  isEventErvkCorrectionRequired,
  isControlObjectsErvkCorrectionRequired,
  isParticipantPositionErvkCorrectionRequired,
  checkForControlObjects,
  checkForEvent,
  checkForInspectors,
}: IErvkCorrectionRequiredInfoProps & IErvkCorrectionRequiredInfoStoreProps) => {
  const isNeedShow =
    (isEventErvkCorrectionRequired && checkForEvent) ||
    (isControlObjectsErvkCorrectionRequired && checkForControlObjects) ||
    (isParticipantPositionErvkCorrectionRequired && checkForInspectors);

  return <> {isNeedShow && <span className="shared-tooltip-kno_link-warning-icon" />}</>;
};

const mapStateToProps = (state: IRootState): IErvkCorrectionRequiredInfoStoreProps => ({
  isEventErvkCorrectionRequired: getIsEventErvkCorrectionRequired(state),
  isControlObjectsErvkCorrectionRequired: getIsControlObjectsErvkCorrectionRequired(state),
  isParticipantPositionErvkCorrectionRequired: getIsParticipantPositionErvkCorrectionRequired(state),
});

export const ErvkCorrectionRequiredInfo = connect(mapStateToProps)(ErvkCorrectionRequiredInfoWithoutStore);
